import {
  type FetchQueryOptions,
  type QueryClient,
} from '@tanstack/react-query';
import { sanityClient } from '../consts/client.const';
import type { PAGE_SLUG } from '../app.type';
import type { RouteProps } from 'react-router';
import type { Page } from '../types/page.type';

export const pageQueryOptions = (slug: PAGE_SLUG): FetchQueryOptions<Page> => ({
  queryKey: ['PAGE', slug],
  queryFn: () => {
    const query = `
        *[_type == "page" && slug.current == $slug][0]{
          "title": title[$lang],
          components[]{
            _type == 'description' => { "content": pl, _key, _type },
            _type == 'mainImage' => {
              _key,
              _type,
              image{ "alt": alt[$lang], "url": asset->url }, 
              "title": title[$lang], 
              "text": description[$lang]
            },
            _type == 'servicesWidget' => {
              "description": services.description[$lang],
              "items": services.items[]->{
                _id,
                "title": title[$lang], 
                "description": description[$lang],
                "shortDescription": shortDescription[$lang],
                iconName,
              },
              _type
            },
            _type == 'vehiclesWidget' => {
              _type,
              "description": vehicles.description[$lang],
              "items": vehicles.items[]->{
                "description": description[$lang],
                specification[]{ "label": label[$lang], "value": value[$lang], },
                features{ "description": description[$lang], items[]{ _key, "content": pl } },
                prices[]{ _key, "period": period[$lang], value },
                "images": gallery.images[]{ _key, alt, "url": asset->url },
                "slug": slug.current,
                name,
              }
            },
            _type == 'faqWidget' => {
              faq[]{ "answer": answer[$lang], "question": question[$lang], _key },
              _key, _type
            }
          },
          seo{"title": title[$lang], "description": description[$lang], "keywords": keywords[][$lang]},
        }
      `;
    const params = { lang: 'pl', slug: slug };

    return sanityClient.fetch<Page>(query.replace(/\s/g, ''), params);
  },
});

export const pageLoader =
  (queryClient: QueryClient, slug: PAGE_SLUG): RouteProps['loader'] =>
  async () => {
    const queryOptions = pageQueryOptions(slug);

    return (
      queryClient.getQueryData(queryOptions.queryKey) ??
      (await queryClient.fetchQuery(queryOptions))
    );
  };
